import { Trans, useTranslation } from 'react-i18next';
import { AlertTriangle } from 'lucide-react';
import { CancelDeletionButton } from './CancelDeletionButton';
import { daysLeft, shortDate } from './format';
import { useAccountDeletionFlag, useDeletionStatus } from './hooks';

/**
 * The pending-deletion banner, above every page of the app (behind the `account_deletion` flag). Everyone in the business sees it; the Cancel
 * button shows only when the server says this person can cancel (an owner), never from the role. Nothing is requested while the flag is off.
 */
export function DeletionBanner() {
  const { t, i18n } = useTranslation('accountDeletion');
  const on = useAccountDeletionFlag();
  const { data } = useDeletionStatus(on);
  if (!on || !data?.pending || !data.delete_after) return null;
  const date = shortDate(data.delete_after, i18n.language, data.timezone);
  const left = daysLeft(data.delete_after);
  return (
    <div role="status" className="flex flex-wrap items-center justify-between gap-3 rounded-lg bg-danger-soft px-3 py-2.5 text-body-sm text-danger-text">
      <p className="m-0 flex min-w-0 flex-1 items-start gap-2">
        <AlertTriangle className="mt-0.5 h-4 w-4 shrink-0" aria-hidden />
        <span>
          {data.can_cancel ? (
            <Trans
              t={t}
              i18nKey="banner.owner"
              values={{ business: data.business_name || t('thisBusinessCap'), date, left: left < 1 ? t('banner.lessThanDay') : t('banner.daysLeft', { count: left }) }}
              components={{ b: <strong className="font-semibold" /> }}
            />
          ) : (
            <Trans t={t} i18nKey="banner.member" values={{ date }} components={{ b: <strong className="font-semibold" /> }} />
          )}
        </span>
      </p>
      {data.can_cancel && <CancelDeletionButton />}
    </div>
  );
}
